import PropTypes from 'prop-types';
import { Box, Alert, Text } from 'roo-ui/components';

const Errors = ({ title, subTitle, errorMessages }) => (
  <Alert icon={{ name: 'warning', color: 'ui.error' }} bg="ui.errorBackground">
    {!!title && (
      <Text fontWeight="bold" data-testid="title">
        {title}
      </Text>
    )}
    {!!subTitle && <Box data-testid="subTitle">{subTitle}</Box>}
    {!!errorMessages &&
      errorMessages.map((errorMessage) => (
        <Box key={errorMessage} data-testid="errorMessage">
          {errorMessage}
        </Box>
      ))}
  </Alert>
);

Errors.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  errorMessages: PropTypes.arrayOf(PropTypes.string),
};

Errors.defaultProps = {
  title: undefined,
  subTitle: undefined,
  errorMessages: undefined,
};

export default Errors;
